import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Head from 'next/head';
import App from '~/src/components/App';
import { withRouter } from 'next/router';
import { isClientSide } from '~/src/helpers/ssr';
import { NoAuthData } from '~/src/components/Internet/onlineServices/data';
import ConnectedNotAuth from '~/src/components/ConnectedNotAuth';

const ymId = 30080914;

class Layout extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    description: PropTypes.string,
    image: PropTypes.string,
    siteName: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    hostname: PropTypes.string,
    relCanonical: PropTypes.string,
    amphtml: PropTypes.string,
    linkedData: PropTypes.string,
    noindex: PropTypes.bool,
    isAuth: PropTypes.bool,
    withMenu: PropTypes.bool,
    clientPersonal: PropTypes.object,
  };

  static defaultProps = {
    title: 'Дом.ру',
    noindex: false,
  };

  constructor(props) {
    super(props);

    this.intervalId = null;
    this.isClientSide = isClientSide();
  }

  static async getInitialProps(ctx) {
    const isAMP = ctx.pathname.indexOf('_amp') !== -1;

    return {
      isAMP,
    };
  }

  componentDidMount() {
    this.setYMUserID();
  }

  setYMUserID = () => {
    const { isAuth, clientPersonal } = this.props;
    if (clientPersonal == null) {
      return;
    }
    const agreement = clientPersonal.agreement;
    if (!this.intervalId && isAuth && agreement) {
      this.intervalId = setInterval(() => {
        if (window.ym && window[`yaCounter${ymId}`]) {
          window.ym(ymId, 'userParams', {
            UserID: agreement,
          });
          clearInterval(this.intervalId);
        }
      }, 1000);
    }
  };

  componentDidUpdate() {
    process.browser && this.setYMUserID();
  }

  componentWillUnmount() {
    if (process.browser && this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  renderClientScripts = () => {
    if (!this.isClientSide) {
      return null;
    }

    return (
      <Fragment>
        <script async src='/static/js/objectFitImages.js' />
      </Fragment>
    );
  };

  render() {
    const {
      amphtml,
      title,
      siteName,
      url,
      description,
      hostname,
      children,
      relCanonical,
      noindex = false,
      isAMP,
      router,
      linkedData,
      withMenu,
      isAuth,
      ...props
    } = this.props;
    const {
      query: { page },
      asPath,
    } = router;

    let noIndex = null;
    if (noindex) {
      noIndex = <meta name='robots' content='noindex' />;
    }

    if (router.asPath.indexOf('/news') !== -1 && page) {
      noIndex = <meta name='robots' content='noindex, follow' />;
    }

    if (
      router.asPath.indexOf('/equipment/note') !== -1 ||
      router.asPath.indexOf('/equipment/smart') !== -1 ||
      router.asPath.indexOf('/zasmotris-village') !== -1 ||
      router.asPath.indexOf('/bundles-land-new-2') !== -1
    ) {
      noIndex = <meta name='robots' content='noindex, nofollow' />;
    }

    let noyaca;
    if (router.pathname === '/') {
      noyaca = <meta name='robots' content='noyaca' />;
    }

    let schemaAgentPage = null;
    let appAgentPage = null;
    if (router.asPath.indexOf('agent') !== -1) {
      appAgentPage = (
        <meta name='apple-itunes-app' content='app-id=569251594' />
      );
      schemaAgentPage = (
        <Fragment>
          <script
            type={'application/ld+json'}
            dangerouslySetInnerHTML={{
              __html: `
                    {
                        "@context": "https://schema.org",
                        "@type": "MobileApplication",
                        "name": "Мой Дом.ру",
                        "operatingSystem": "Android, iOS",
                        "applicationCategory": "https://schema.org/CommunicationApplication",
                        "aggregateRating": {
                        "@type": "AggregateRating",
                        "ratingValue": "4.2",
                        "ratingCount": "7472"
                    },
                        "offers": {
                        "@type": "Offer",
                        "price": "0",
                        "priceCurrency": "RUB"
                    },
                        "url": "https://play.google.com/store/apps/details?id=com.ertelecom.agent&hl=ru"
                    }
                `,
            }}
          />
        </Fragment>
      );
    } else if (linkedData) {
      schemaAgentPage = (
        <script
          type={'application/ld+json'}
          dangerouslySetInnerHTML={{ __html: linkedData }}
        />
      );
    }
    const t = router.pathname;

    return (
      <Fragment>
        <Head>
          <title>{title}</title>
          {this.renderClientScripts()}
          <script>window.SC_DISABLE_SPEEDY = true</script>
          <meta property='og:type' content='article' />
          <meta name='twitter:card' content='summary' />
          <meta name='twitter:creator' content='@domru_' />
          <meta name='twitter:site' content='@domru_' />
          <meta name='verify-reformal' content='06f45ba2cda3fd2ce81181b5' />
          <meta name='yandex-verification' content='36650e0e0c49aa3e' />
          <meta name='theme-color' content='#000000' />
          <link rel='shortcut icon' href='/static/newFavicon.ico' />
          <link rel='apple-touch-icon' href='/static/newFaviconApple.png' />
          {!isAMP && (
            <meta
              name='viewport'
              content='width=device-width, initial-scale=1, shrink-to-fit=no'
            />
          )}
          <meta property='og:site_name' content={siteName || title} />
          <meta property='og:title' content={title} />
          <meta name='twitter:title' content={title} />
          <meta
            name='twitter:image'
            content={'data:image/vnd.microsoft.icon;base64,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'}
          />
          {noIndex}
          {url && <meta property='og:url' content={url} />}
          {<meta property='og:image' content={'data:image/vnd.microsoft.icon;base64,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'} />}
          {description && (
            <Fragment>
              <meta property='og:description' content={description} />
              <meta name='description' content={description} />
              <meta name='twitter:description' content={description} />
            </Fragment>
          )}
          {relCanonical && <link rel='canonical' href={relCanonical} />}
          {amphtml && <link rel='amphtml' href={amphtml} />}
          {schemaAgentPage}
          {appAgentPage}
          {noyaca}
        </Head>
        <App hostname={hostname} asPath={asPath} withMenu={withMenu} {...props}>
          {isAuth || t === '/user/recovery/pass'
            ? children
            : <ConnectedNotAuth data={NoAuthData}/>
          }
        </App>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuth: state.auth.isAuth,
  clientPersonal: state.auth.clientPersonal,
});

export default withRouter(connect(mapStateToProps)(Layout));
